export default __webpack_public_path__ + "static/media/fruit9.6fa6bd86.jpg";